import { useTheme, ChartState, DEFAULT_BORDER_RADIUS } from '@shopify/polaris-viz-core';
import { jsxs, jsx } from 'react/jsx-runtime';
import { ErrorText } from '../ErrorText/ErrorText.js';

function SparkSkeleton({
  dimensions,
  state,
  errorText
}) {
  const {
    width,
    height
  } = dimensions;
  const {
    grid: {
      color: gridColor
    }
  } = useTheme();
  return /*#__PURE__*/jsxs("svg", {
    viewBox: `0 0 ${width} ${height}`,
    children: [state === ChartState.Loading && /*#__PURE__*/jsx("rect", {
      x: 0,
      y: 0,
      width: width,
      height: height,
      fill: gridColor,
      rx: DEFAULT_BORDER_RADIUS
    }), state === ChartState.Error && /*#__PURE__*/jsx(ErrorText, {
      errorText: errorText,
      width: width,
      height: height
    })]
  });
}

export { SparkSkeleton };
